module.exports = __webpack_public_path__ + "static/media/Icono informes.fc218d49.svg";